import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { Box } from "@gemini/core";
import { useI18n } from "@/shared/hooks";
import { useBrandContext } from "@/shared/contexts";
import { PrivacyPolicyModal } from "../Modals/PrivacyPolicyModal";
import { CallTrackingModal } from "../Modals/CallTrackingModal";
export const LegalText = ({ isModal }) => {
    const containerRef = useRef(null);
    const { t } = useI18n();
    const { legal: { link3 }, } = useBrandContext();
    const [isCallTrackingModalOpen, setIsCallTrackingModalOpen] = useState(false);
    const [isPrivacyPolicyModalOpen, setIsPrivacyPolicyModalOpen] = useState(false);
    const legalText = t("contact.form.legal_text.desktop_v2");
    const legalTextWithLinks = legalText
        .replace("{link3}", `<a target="_blank" href="${link3.href}">${t("contact.form.legal_text.link_label_three")}</a>`)
        .replace("{modal1}", `<a href="#" data-action="callTracking">${t("contact.form.legal_text.modal_label_one")}</a>`)
        .replace("{modal2}", `<a href="#" data-action="privacyPolicy">${t("contact.form.legal_text.modal_label_two")}</a>`);
    const toggleCallTrackingModal = useCallback(() => setIsCallTrackingModalOpen(!isCallTrackingModalOpen), [isCallTrackingModalOpen]);
    const togglePrivacyPolicyModal = useCallback(() => setIsPrivacyPolicyModalOpen(!isPrivacyPolicyModalOpen), [isPrivacyPolicyModalOpen]);
    useEffect(() => {
        const el = containerRef.current;
        if (!el)
            return;
        const handler = (e) => {
            // eslint-disable-next-line no-restricted-globals
            const target = e.target;
            const action = target.getAttribute("data-action");
            if (!action)
                return;
            e.preventDefault();
            if (action === "callTracking") {
                toggleCallTrackingModal();
            }
            if (action === "privacyPolicy") {
                togglePrivacyPolicyModal();
            }
        };
        el.addEventListener("click", handler);
        return () => {
            el.removeEventListener("click", handler);
        };
    }, [toggleCallTrackingModal, togglePrivacyPolicyModal]);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { ref: containerRef, paddingTop: 0, typography: "typography.body.11.regular", marginBottom: {
                    "breakpoint.xs": isModal ? "spacing.40" : "spacing.2",
                    "breakpoint.md": "0",
                }, dangerouslySetInnerHTML: { __html: legalTextWithLinks } }), _jsx(PrivacyPolicyModal, { isOpen: isPrivacyPolicyModalOpen, onOpenChange: togglePrivacyPolicyModal }), _jsx(CallTrackingModal, { isOpen: isCallTrackingModalOpen, onOpenChange: toggleCallTrackingModal })] }));
};
